<template>
    <div :id="popupId" :class="onModalClass" ref="cursor">
        <button class="close-btn" aria-label="상세보기 화면 닫기" @click="doCloseWinEvent"></button>
        <div class="popup-conts">
            <div v-if="eventDtlInfo?.eventFileUrl" class="pop-img">
                <img :src="eventDtlInfo.eventFileUrl" alt="이벤트 이미지" />
            </div>
            <div class="pop-detail">
                <div class="ev-top-info">
                    <h2 class="tit">{{ eventDtlInfo.eventTitle }}</h2>
                    <p class="period">{{ eventDtlInfo.eventTerm }}</p>
                </div>
                <!-- 요약 설명(editor) -->
                <div v-if="eventDtlInfo.eventAbsrt !== ''" class="ev-mid-info" v-html="eventDtlInfo.eventAbsrt" />
                <!-- //요약 설명(editor) -->
                <!-- 내용(editor) -->
                <div class="ev-btm-detail" v-html="eventDtlInfo.eventConts" />
                <!-- //내용(editor) -->
            </div>
        </div>
    </div>
</template>

<script setup>
    defineOptions({
        name: 'EventDetail',
    });

    import { onMounted, onUpdated, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import { useRootStore } from '@/stores/modules';
    import { setHeaderTitle } from '@/utils/commonUtil';

    const $route = useRoute();
    const emit = defineEmits(['close']);

    const isModal = ref(false);
    const eventId = ref('');
    const popupId = ref('');
    const onModalClass = ref('');
    const eventDtlInfo = ref({});
    const cursor = ref(null);

    const getEventDetail = async (eventId, gbn) => {
        const url = `/event/detail?eventId=${eventId}`;
        const res = await useRootStore().getStarFieldInfo(url);

        if (res.status === 200) {
            eventDtlInfo.value = res.data.eventDetail;

            // 공유하기 정보 설정
            const { seo } = eventDtlInfo.value;
            if (seo) {
                const { title, description, image, url } = seo;
                useRootStore().setShareInfo({
                    title,
                    description,
                    image,
                    url,
                    id: eventId.value,
                });
            } else {
                useRootStore().setShareInfo(null);
            }

            if (gbn !== 'MODAL') {
                isModal.value = false;

                // 팝업 CSS 설정
                onModalClass.value = 'popup-wrap';

                // 팝업ID변경 CSS제어
                popupId.value = 'popup-page';

                // 페이지이동인 경우 브라우저 뒤로가기버튼 제어
                localStorage.setItem('gotoPage', 'Y');

                // 타이틀 표시
                if (gbn === 'PAGE') {
                    let strTitle = eventDtlInfo.value.eventTitle;
                    const maxLength = 12;
                    if (strTitle.length > maxLength) {
                        strTitle = strTitle.substring(0, maxLength) + '...';
                    }
                    setHeaderTitle(strTitle);
                }
            } else {
                isModal.value = true;

                // 팝업 CSS의 형태
                onModalClass.value = 'popup-wrap slideUp';

                cursor.value?.scrollTo({ top: 0 });
            }
        }
    };
    // [X]버튼 클릭시
    const doCloseWinEvent = () => {
        isModal.value = false;
        // 바깥부분 Scroll처리
        document.body.classList.remove('no-scroll');

        onModalClass.value = 'popup-wrap slideDown';
        // 모달 감추기
        setTimeout(() => {
            onModalClass.value = '';
            emit('close');
        }, 300);
    };

    onUpdated(() => {
        if (isModal.value) {
            //focus 작업 시작======================
            const modal = cursor.value;
            const modalcontents = document.querySelector('.popup-conts');
            modalcontents.setAttribute('tabindex', 1);

            const focusableEls = modal.querySelectorAll(
                'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, img, object, div, embed',
            );
            focusableEls.forEach(function (item, index) {
                item.setAttribute('tabindex', index + 2);
            });

            const firstFocusableEl = focusableEls[0];
            firstFocusableEl.focus();

            const lastFocusableEl = focusableEls[focusableEls.length - 1];

            const modalTrapFocus = (event) => {
                if (event.key === 'Tab') {
                    if (document.activeElement === lastFocusableEl && !event.shiftKey) {
                        firstFocusableEl.focus();
                        event.preventDefault();
                    } else if (document.activeElement === firstFocusableEl && event.shiftKey) {
                        lastFocusableEl.focus();
                        event.preventDefault();
                    }
                }

                if (event.key === 'Escape') {
                    doCloseWinEvent();
                }
            };
            document.addEventListener('keydown', modalTrapFocus);
            //focus 작업 종료======================
        }
    });
    onMounted(() => {
        // 이벤트상세(페이지이동)
        eventId.value = $route.params.eventId ? $route.params.eventId : '';

        // 이벤트상세(팝업) - 새창
        let sendData = null;
        try {
            sendData = JSON.parse(localStorage.getItem('sendData'));
        } catch (err) {
            console.log(err);
        }

        // 이벤트상세
        if (eventId.value) {
            getEventDetail(eventId.value, 'PAGE');

            // 팝업의 경우
        } else if (sendData && sendData.eventId) {
            getEventDetail(sendData.eventId, 'NEWPOP');

            // 전달되는 인수의 초기화
            localStorage.setItem('sendData', null);
        }
    });

    defineExpose({ getEventDetail });
</script>
